import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useStyles from "./styles";
import logo from "../../assets/images/logo.svg";
import referImg from "../../assets/images/refer.png";
import InputGroup from "../../components/FormComponent/InputGroup";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import Button from "../../components/Button";
import { httprequest } from "../../data/api";

const GenerateLink = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    schoolName: "",
    city: "",
    relationship: "Teacher",
    email: "",
    phone: "",
    consent: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.schoolName ||
      !formData.city ||
      !formData.email ||
      !formData.relationship ||
      !formData.consent ||
      !String(formData.phone || "").trim()
    ) {
      toast.error("Please fill all required fields (including phone) and consent to being contacted.");

      return;
    }

    const phoneDigits = String(formData.phone || "").replace(/\D/g, "");
    if (phoneDigits.length < 7 || phoneDigits.length > 15) {
      toast.error("Please enter a valid phone number (7–15 digits).");

      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        school_name: formData.schoolName,
        city: formData.city,
        relationship: formData.relationship.toLowerCase(),
        email: formData.email,
        phone_number: String(formData.phone).trim()
      };

      const response = await httprequest.post("/api/v1/referrals/generate", payload);

      if (response?.data?.data) {
        toast.success(response?.data?.message || "Referral link generated successfully!");
        navigate("/referral/success", {
          state: {
            referralLink: response.data.data.referral_link,
            referralCode: response.data.data.code
          }
        });
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to generate referral link");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={classes.referralWrapper}>
      <div className={classes.referralLeft}>
        <div className={classes.referralLogoContainer}>
          <img src={logo} alt="Shelf21 Logo" className={classes.referralLogo} />
        </div>

        <div className={classes.referralIllustration}>
          <img src={referImg} alt="Referral Illustration" className={classes.referralImg} />
        </div>

        <div className={classes.referralLeftText}>
          <h1>Help your school get on Shelf21</h1>
          <p>Recommend Shelf21. Earn lifetime benefits.</p>
        </div>
      </div>

      <div className={classes.referralRight}>
        <div className={classes.referralFormCard}>
          <div className={classes.referralFormHeader}>
            <h2>Refer a school to shelf21</h2>
            <p>Please fill the information below</p>
          </div>

          <form className={classes.referralForm} onSubmit={handleSubmit}>
            <div className={classes.inputGroupContainer}>
              <InputGroup
                label="School Name"
                required={true}
                inputType="text"
                inputName="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
              />
            </div>

            <div className={classes.inputGroupContainer}>
              <InputGroup
                label="City"
                required={true}
                inputType="text"
                inputName="city"
                value={formData.city}
                onChange={handleChange}
              />
            </div>

            <div className={classes.inputGroupContainer}>
              <SelectGroup label="Your Relationship to the School" required={true}>
                <select
                  name="relationship"
                  className={classes.referralSelect}
                  value={formData.relationship}
                  onChange={handleChange}
                >
                  <option value="Teacher">Teacher</option>
                  <option value="Principal">Principal</option>
                  <option value="Administrator">Administrator</option>
                  <option value="Parent">Parent</option>
                  <option value="Other">Other</option>
                </select>
              </SelectGroup>
            </div>

            <div className={classes.inputGroupContainer}>
              <InputGroup
                label="Email"
                required={true}
                inputType="email"
                inputName="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className={classes.inputGroupContainer}>
              <InputGroup
                label="Phone Number"
                required={true}
                inputType="tel"
                inputName="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className={classes.checkboxContainer}>
              <label className={classes.checkboxLabel}>
                <input
                  type="checkbox"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                  required
                />
                <span className={classes.checkboxText}>I'm okay with being contacted if we need more details about this referral</span>
              </label>
            </div>

            <div className={classes.submitButtonContainer}>
              <Button
                buttonName={isLoading ? "Generating..." : "Generate referral link"}
                variant="primary"
                buttonSize="full"
                color="btndefault"
                type="submit"
                disabled={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GenerateLink;
